import { render } from "./404.vue?vue&type=template&id=d344683c&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=d344683c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d344683c"

export default script